import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001/api';
const API_ROOT_URL = API_BASE_URL.replace(/\/api\/?$/, '');

export const buildApiUrl = (path) => {
  if (!path) return API_BASE_URL;
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith('/api/')) return `${API_ROOT_URL}${path}`;
  if (path.startsWith('/')) return `${API_BASE_URL}${path}`;
  return `${API_BASE_URL}/${path}`;
};

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const analyticsAPI = {
  getDailyDashboard: () => apiClient.get('/analytics/daily'),
  getWeeklyReport: () => apiClient.get('/analytics/weekly'),
  getQuarterlyReport: () => apiClient.get('/analytics/quarterly'),
  getDepartmentPerformance: () => apiClient.get('/analytics/department-performance')
};

export const reportsAPI = {
  getDailyDashboard: () => apiClient.get('/reports/daily'),
  getWeeklyReport: () => apiClient.get('/reports/weekly'),
  getQuarterlyReport: () => apiClient.get('/reports/quarterly'),
  getTopIssuesReport: (limit = 15) => apiClient.get('/reports/top-issues', { params: { limit } }),
  getCriticalComplaints: () => apiClient.get('/reports/critical-complaints'),
  getOverdueComplaints: () => apiClient.get('/reports/overdue-complaints'),
  getSatisfactionMetrics: () => apiClient.get('/reports/satisfaction-metrics'),
  getGeographicalData: () => apiClient.get('/reports/geographical'),
  getComplaintsByDivision: () => apiClient.get('/reports/complaints-by-division'),
  getComplaintsByDistrict: (divisionId) => apiClient.get('/reports/complaints-by-district', { params: { division_id: divisionId } }),
  getMapData: () => apiClient.get('/reports/map-data')
};

export const statisticsAPI = {
  getOverview: () => apiClient.get('/statistics/overview'),
  getCriticalComplaints: () => apiClient.get('/statistics/critical'),
  getOverdueComplaints: () => apiClient.get('/statistics/overdue')
};

// New Dashboard API endpoints
export const dashboardAPI = {
  getComprehensiveDashboard: () => apiClient.get('/dashboard'),
  getCategoryAnalytics: () => apiClient.get('/dashboard/categories'),
  getComplaintTypeAnalytics: () => apiClient.get('/dashboard/complaint-types'),
  getStatusDistribution: () => apiClient.get('/dashboard/status-distribution'),
  getDepartmentAnalytics: () => apiClient.get('/dashboard/departments'),
  getMonthlyTrend: (months = 12) => apiClient.get('/dashboard/trends/monthly', { params: { months } }),
  getDailyTrend: (days = 30) => apiClient.get('/dashboard/trends/daily', { params: { days } }),
  getFeedbackAnalytics: () => apiClient.get('/dashboard/feedback/analytics'),
  getFeedbackByRating: () => apiClient.get('/dashboard/feedback/by-rating'),
  getTopComplainants: (limit = 10) => apiClient.get('/dashboard/top-complainants', { params: { limit } }),
  getSLAMetrics: () => apiClient.get('/dashboard/sla-metrics'),
  getLocationAnalytics: () => apiClient.get('/dashboard/location-analytics')
};

// Advanced Analytics API endpoints
export const advancedAnalyticsAPI = {
  getHourlyAnalytics: () => apiClient.get('/advanced/analytics/hourly'),
  getDeviceAnalytics: () => apiClient.get('/advanced/analytics/devices'),
  getAdminPerformance: () => apiClient.get('/advanced/analytics/admin-performance'),
  getComplaintTypeDetailed: () => apiClient.get('/advanced/analytics/complaint-types-detailed'),
  getDropReasons: () => apiClient.get('/advanced/analytics/drop-reasons'),
  getFeedbackSentiment: () => apiClient.get('/advanced/analytics/feedback-sentiment'),
  getDistrictRankings: () => apiClient.get('/advanced/analytics/district-rankings'),
  getCategoryTrends: () => apiClient.get('/advanced/analytics/category-trends'),
  getCategoryComparison: () => apiClient.get('/advanced/analytics/category-comparison'),
  getRepeatComplainants: (limit = 100) => apiClient.get('/advanced/analytics/repeat-complainants', { params: { limit } }),
  getResolutionTimeAnalytics: () => apiClient.get('/advanced/analytics/resolution-time'),
  getStatusFlowAnalytics: () => apiClient.get('/advanced/analytics/status-flow'),
  getMonthlyYearlyTrends: () => apiClient.get('/advanced/analytics/monthly-yearly'),
  getEscalationAnalytics: () => apiClient.get('/advanced/analytics/escalations'),
  getUserSegmentation: () => apiClient.get('/advanced/analytics/user-segmentation'),
  getPerformanceIndicators: () => apiClient.get('/advanced/analytics/performance-indicators'),
  getComplianceReport: () => apiClient.get('/advanced/analytics/compliance'),
  getExecutiveSummary: () => apiClient.get('/advanced/analytics/executive-summary'),

  // NEW: Department and Geographic Analytics
  getDepartmentAnalytics: () => apiClient.get('/advanced/analytics/departments'),
  getDistrictDetailedAnalytics: () => apiClient.get('/advanced/analytics/districts-detailed'),
  getTehsilAnalytics: () => apiClient.get('/advanced/analytics/tehsils'),
  getComplaintTypeAnalytics: () => apiClient.get('/advanced/analytics/complaint-types'),
  getGeographicHotspots: () => apiClient.get('/advanced/analytics/geographic-hotspots'),
  getDepartmentDistrictCrossAnalytics: () => apiClient.get('/advanced/analytics/dept-district-cross'),
  getSeverityClassification: () => apiClient.get('/advanced/analytics/severity-classification'),
  getGeographicComparisonTable: () => apiClient.get('/advanced/analytics/districts-comparison'),
  getDepartmentPerformance: () => apiClient.get('/advanced/analytics/department-performance'),
  getComplaintVolumeTrends: () => apiClient.get('/advanced/analytics/complaint-volume-trends')
};

export const atrackAnalyticsAPI = {
  getDashboard: () => apiClient.get('/atrack/analytics/dashboard')
};

export const ipmsAnalyticsAPI = {
  getDashboard: () => apiClient.get('/ipms/analytics/dashboard')
};

export default apiClient;
